import { useEffect, useRef, useState } from "react";

/** An element's content width, following resizes. `null` until measured and
 *  wherever ResizeObserver is missing (happy-dom under test), which callers
 *  treat as narrow. */
export function useElementWidth<T extends HTMLElement>() {
    const ref = useRef<T | null>(null);
    const [width, setWidth] = useState<number | null>(null);
    useEffect(() => {
        const element = ref.current;
        if (!element || typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver((entries) => {
            const next = entries[0]?.contentRect.width;
            if (next !== undefined) setWidth((previous) => (previous === next ? previous : next));
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);
    return { ref, width };
}
